import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import Api from "../Api/Api";
import * as yup from "yup";

function SponsorPage() {
  const [singupContral, setSingupContral] = useState(true);
  const [loginButtonLoader, setLoginButtonLoader] = useState(true);

  const centerDivRef = useRef(null);
  const [gameNoAuth, setGameNoAuth] = useState(false);
  const navigate = useNavigate();
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const hasUParam = queryParams.has("u");
//   const uValue = queryParams.get("u");
  const param = useParams();

//   console.log("location", singupContral);
  // login section
//   console.log("hasParam", hasUParam, uValue, param.name);

  // Register page

  const initalValueReg = {
    name: "",
  };

  const validationReg = yup.object({
    name: yup.string().required("Weshareabundance Sponsor Name is required"),
  });

  const RegisterSubmit = async (values) => {
    setGameNoAuth(true);
  };

  const formikreg = useFormik({
    initialValues: initalValueReg,
    validationSchema: validationReg,
    onSubmit: (values) => RegisterSubmit(values),
  });

  useEffect(() => {
    if (param.name) {
      console.log("haaa", param.name);
      //   setSingupContral(false);
      // console.log("Signup Val")
      //   formikreg.values.name = uValue;
      //   const timer = setTimeout(()=>{
      formikreg.setFieldValue("name", param.name);

      //   },60*60);
      //   return () => clearTimeout(timer);
    }
  }, [param.name]);

  // console.log("formikreg", formikreg.values.name);
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null; // Return null if cookie doesn't exist
}

  useEffect(() => {
    window.scrollTo(0, 0);
    // console.log("cookie sponsor", getCookie("sponsorName"));
    // formikreg.setFieldValue("name", getCookie("sponsorName"));
  }, []);

  useEffect(() => {
    if (centerDivRef.current) {
      const parentDiv = centerDivRef.current.parentNode; // Access the parent div

      // Log or manipulate the parent div as needed
      if (parentDiv) {
        const grandParentDiv = parentDiv.parentNode;
        const grandGrandParentDiv = grandParentDiv.parentNode;
        const headerSection = parentDiv.querySelector(".header-section");
        const headerMenu = parentDiv.querySelector(".header-menu");
        const sidebar = grandGrandParentDiv.querySelector(
          ".sidebar.break-point-sm.has-bg-image"
        );

        if (headerSection) headerSection.style.display = "none";
        if (headerMenu) headerMenu.style.display = "none";
        if (sidebar) sidebar.style.display = "none";
      }
    }
  }, []);

  const resetParentProperty = () => {
    const parentDiv = centerDivRef.current.parentNode;
    const grandParentDiv = parentDiv.parentNode;
    const grandGrandParentDiv = grandParentDiv.parentNode;
    const headerSection = parentDiv.querySelector(".header-section");
    const headerMenu = parentDiv.querySelector(".header-menu");
    const sidebar = grandGrandParentDiv.querySelector(
      ".sidebar.break-point-sm.has-bg-image"
    );

    if (headerSection) headerSection.style.display = "none";
    if (headerMenu) headerMenu.style.display = "none";
    if (sidebar) sidebar.style.display = "none";
  };

//   useEffect(() => {
//     // console.log("nav");
//     const handlePopState = () => {
//       resetParentProperty(); // Reset parent properties if needed
//       // navigate("/", { replace: true }); // Navigate to home and replace history
//     };

//     window.addEventListener("popstate", handlePopState);

//     return () => {
//       window.removeEventListener("popstate", handlePopState);
//     };
//   }, [navigate]);

  return (
    <>
      <ToastContainer />
      <div className="center" ref={centerDivRef}>
        <div className="video-form container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="log-img">
                <img src="/assets/images/login.png" />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <form onSubmit={formikreg.handleSubmit} style={{ marginLeft: 0 }}>
                <Link
                  to="/"
                  onClick={() => {
                    //   formik.resetForm(); // Reset login form
                    formikreg.resetForm(); // Reset registration form
                    resetParentProperty();
                  }}
                >
                  <i
                    className="fa-solid fa-angle-left"
                    style={{ color: "black" }}
                  ></i>
                </Link>
                <div className="form-header">
                  <h2>Create Account</h2>
                  <p style={{ margin: "7px" }}>Let’s Create Account Together</p>
                  {/* <p>Signup on We Share Abundance website and come back to our site to login and play games</p> */}
                </div>
                <label for="email">
                  <b>Weshareabundance Sponsor's Name</b>
                </label>
                <input
                  type="Text"
                  name="name"
                  value={formikreg.values.name}
                  onChange={formikreg.handleChange}
                  placeholder="Please enter your Weshareabundance (WSA) sponsor's username "
                  style={{ color: "black", cursor: "text" }}
                />
                {formikreg.touched.name && formikreg.errors.name ? (
                  <div className="text-danger">{formikreg.errors.name}</div>
                ) : null}

                <button
                  type="submit"
                  className="mt-5"
                  // onClick={() => {
                  //   setGameNoAuth(true);
                  // }}
                >
                  <a> {loginButtonLoader ? "Sign up" : "Please wait"}</a>
                </button>
                <a
                  onClick={() => {
                    navigate("/login")
                    // setSingupContral(!singupContral);
                    //   formik.resetForm(); // Reset login form
                    formikreg.resetForm(); // Reset registration form
                    resetParentProperty()
                  }}
                  className="signup-like"
                >
                  Already have an account? <span> Log In</span>
                </a>
              </form>
            </div>
          </div>
        </div>
      </div>

      {gameNoAuth ? (
        <div
          className="modal fade show"
          id="exampleModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{
            display: gameNoAuth ? "block" : "none",
            paddingTop: "190px",
          }}
        >
          <div className="modal-dialog">
            <div
              className="modal-content"
              style={{ backgroundColor: "#b6b8dc" }}
            >
              <div
                className="modal-body"
                style={{ paddingTop: "8px", paddingBottom: "13px" }}
              >
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setGameNoAuth(false)}
                ></button>

                <div className="logo poup">
                  <Link to="/">
                    <img
                      src="/assets/images/logo-text.png"
                      className="logo-text d-xxl-block  "
                      alt="logo-text"
                    />
                  </Link>
                </div>

                <div className="d-flex justify-content-center align-items-center">
                  <div className="btn-area alt-bg">
                    <h5
                      style={{
                        color: "#20205f",
                        textAlign: "center",
                        textTransform: "none",
                      }}
                    >
                      You will now be redirected to our parent site
                      membersnew.weshareaundance.com for registration.
                    </h5>
                    <h6 className="mt-3" style={{ textTransform: "none" }}>
                      Come back to our site Trivia Fun to login and enjoy
                      playing
                    </h6>
                    <div className="btn-area alt-bg border-line">
                      <div className="btn-area alt-bg border-line">
                        <a
                          onClick={() => {
                            setGameNoAuth(false);
                            window.open(
                              `https://membersnew.weshareabundance.com/register?u=${formikreg.values.name}`,
                              "_blank"
                            );
                          }}
                          className="box-style btn-box d-center hoverstyle"
                          // style={{ marginTop: "2px" }}
                        >
                          {" "}
                          Okay, Sign up
                          {/* {loading ? "Please wait" : "Login"} */}
                        </a>
                        <a
                          onClick={() => setGameNoAuth(false)}
                          className="box-style btn-box d-center hoverstyle"
                        >
                          {" "}
                          Cancel
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default SponsorPage;
